export class PdfCreationError extends Error{
    constructor() {
        super("Error creating pdf");
    }
}